import React from "react";
import {TableContext,RowContext,TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {fetchDataSecurityAgreement, getFeConfig, uploadDataSecurityAgreement, visualize} from "../../api/api";
import {Button, Modal, Upload, Space, Typography, notification} from "antd";
import '../../styles/GDPRDocuments.css'
import {Form} from "@q4us-sw/q4us-ui";
import {CloudUploadOutlined, InboxOutlined,EyeOutlined} from '@ant-design/icons'
import {unstable_batchedUpdates} from "react-dom";


const UploadItem = ({value, onChange})=>{

    return <Upload.Dragger
        accept={`.pdf`}
        maxCount={1}
        fileList={value ? [value]: []}
        progress={{
            showInfo: false
        }}
        onRemove={()=>onChange(undefined)}
        customRequest={(opt)=>{
            onChange(opt.file)
            opt.onSuccess()
        }}>
        <p className="ant-upload-drag-icon">
            <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
    </Upload.Dragger>
}




export const AgreementForm = ({onSubmit, onCancel}) => {

    return <TableContext.Consumer>
        {
            table => <Form
                maxHeight={`60vh`}
                schema={`reporting_data_security_agreements`}

                config={async (schema) => {
                    const {data: {rows = []} = {}} = await getFeConfig(schema) || {}
                    return rows;
                }}

                visibilityValidator={(schema, {name}, form) => {
                    if (schema === 'reporting_data_security_agreements') {
                        return name !== 'created' && name !== 'name'
                    }
                    return true;
                }}
                overrideComponent={(schema, element, form)=>{
                    if(schema === 'reporting_data_security_agreements'){
                        if(element.name === 'oid'){
                            return <UploadItem key={`oid`}/>
                        }
                    }
                }}

                rejected={()=>onCancel()}
                submit={async (values) => {
                    table?.setLoading(true)
                    const {language, oid} = values
                    const formData = new FormData();
                    formData.append(language,oid);
                    const res = await uploadDataSecurityAgreement(formData)
                    if(res.status === 200){
                        const tableData = await table?.props.fetchData({schema: table?.props.schema}) || {};
                        notification.success({message: `File [${oid.name}] uploaded`})
                        unstable_batchedUpdates(() => {
                            table?.setData(tableData.data?.rows || [])
                            table?.setLoading(false)
                        })
                    }else{
                        notification.error({message: `File [${oid.name}] upload failed`})
                        table?.setLoading(false)
                    }
                    return await onSubmit()
                }}/>
        }
    </TableContext.Consumer>
};


export const ReportingDataSecurityAgreements = (props) => {

    const [open,setOpen] = React.useState(false)

    return <div className={`gdpr-content`}>
        <TableV2
            header={<div className={`gdpr-header`}>
                <Typography.Title level={3}>Data Security Agreements</Typography.Title>
                <div className={`spacer`}/>
                <Button onClick={()=>setOpen(true)}>Add New Agreement</Button>
            </div>}
            fetchConfig={async (schema) => {
                return await getFeConfig(schema) || {}
            }}
            fetchData={async (request) => {
                return await visualize("reporting_data_security_agreements")
            }}
            action={{
                name: 'oid',
                title: '',
                options: TableOperation.Custom,
                minWidth: 45
            }}
            getCustomAction={(o)=>{
                return [<RowContext.Consumer>
                    {row => <TableContext.Consumer>
                        {table=><Space>
                            <Button key={`show`} icon={<EyeOutlined/>} onClick={async () => {
                                console.log(row.row.language)
                                await fetchDataSecurityAgreement(row.row.language)
                            }}/>
                            <Upload
                                accept={`.pdf`}
                                progress={{
                                    showInfo: false
                                }}
                                fileList={[]}
                                customRequest={async (opt)=>{
                                    table?.setLoading(true)
                                    const formData = new FormData();
                                    formData.append(row.row.language,opt.file);
                                    const res = await uploadDataSecurityAgreement(formData)
                                    if(res.status === 200){
                                        const tableData = await table?.props.fetchData({schema: table?.props.schema}) || {};
                                        notification.success({message: `File [${opt.file.name}] uploaded`})
                                        unstable_batchedUpdates(() => {
                                            table?.setData(tableData.data?.rows || [])
                                            table?.setLoading(false)
                                        })
                                        opt.onSuccess(res.data, res.request)
                                    }else{
                                        notification.error({message: `File [${opt.filename}] upload failed`})
                                        table?.setLoading(false)
                                    }
                                }}
                            >
                                <Button key={`upload`} icon={<CloudUploadOutlined/>}/>
                            </Upload>

                        </Space>}
                    </TableContext.Consumer>
                    }
                </RowContext.Consumer>]
            }}
            schema={`reporting_data_security_agreements`}
        >
            <Modal
                onCancel={() => setOpen(false)}
                footer={null}
                closable={true}
                title={'Add Agreement'}
                visible={open}
            >
                <AgreementForm onCancel={()=>setOpen(false)} onSubmit={()=> {
                    setOpen(false)
                    return true;
                }}/>
            </Modal>
        </TableV2>
    </div>
}
